import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { MatDivider } from '@angular/material/divider';
import { CommonModule } from '@angular/common';


// user-profile.component.ts
@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.css',
  imports: [MatDivider, CommonModule],
})
export class UserProfileComponent implements OnInit {
  user: any;
  isLoading = true;
  error = false;
  
  constructor(
    private route: ActivatedRoute,
    private userService: UserService
  ) {}
  
  ngOnInit() {
    this.route.params.subscribe(params => {
      const userId = params['id'];
      this.loadUserProfile(userId);
    });
  }
  
  loadUserProfile(userId: string) {
    this.userService.getUserById(userId).subscribe({
      next: (res) => {
        this.user = res;
        this.isLoading = false;
      },
      error: (err) => {
        console.error(err);
        this.error = true;
        this.isLoading = false;
      }
    });
  }

  formatPhone(phone: string | undefined): string {
    if (!phone) return '';
    const cleaned = phone.replace(/\D/g, '');
    if (cleaned.length === 10) {
      return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    }
    return phone;
  }
}
